const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  // DOMAIN SERVER MỚI
  development: {
    api: "https://kcnxuanque-api.cgis.asia/",
    media_url: "https://kcnxuanque-api.cgis.asia/",
    domainAdminSide: "http://localhost:3000",
    domainUserSide: "http://localhost:3000",
    domainName: "",
    workSpace: "dongnai_kcnxuanque",
    wmsBaseLink: "https://geo3.cgis.asia/geoserver/wms/",
    datastore: 'dongnai_kcnxuanque',
    gwcUrl: 'https://geo3.cgis.asia/geoserver/gwc/service/wms/'
    // wmsBaseLink: "https://geoserver.phutho.gov.vn/geoserver/gwc/service/wms/",
  },
    production: {
      api: "https://kcnxuanque-api.cgis.asia/",
      media_url: "https://kcnxuanque-api.cgis.asia/",
      domainAdminSide: "https://admin.kcnxuanque.cgis.asia",
      domainUserSide: "https://kcnxuanque.cgis.asia",
      domainName: "kcnxuanque.cgis.asia",
      workSpace: "dongnai_kcnxuanque",
      wmsBaseLink: "https://geo3.cgis.asia/geoserver/wms/",
      datastore: 'dongnai_kcnxuanque',
      gwcUrl: 'https://geo3.cgis.asia/geoserver/gwc/service/wms/'
      // wmsBaseLink: "https://geo.cgis.asia/geoserver/gwc/service/wms/",
  }
};

module.exports = apiEnvironment[env];